"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_CHANNEL_FRAGMENT = exports.PUBLIC_VIDEO_FRAGMENT = void 0;
const helpers_1 = require("../../client/helpers");
exports.PUBLIC_VIDEO_FRAGMENT = `
  fragment PublicVideoFragment on Video {
    id
    title
    description
    genre
    type
    type
    source
    publisher
    status
    tags
    categories
    source
    createdAt
    viewerOptions {
      signupRequired
      trailerEnabled
      trailerUseUploaded
    }
    cards {
      total
    }
    uploadedTrailer {
      externalId
    }
    defaultTrailer {
      duration
    }
    content {
      externalUrl
      externalId
      duration
    }
    pricing {
      type
      price
      period
      enabled
      currency
    }
    downloadOptions {
      enabled
    }
    poster {
      selected
    }
    cover {
      selected
    }
    crew {
      role
      name
    }
    cast {
      role
      name
    }
    embedOptions {
      enabled
      showInfo
      showShare
      showTitle
      showLogo
      logoVisibility
      logoUrl
    }
    live {
      status
      startedAt
    }
    play(type: CONTENT) {
      entity {
        hls
      }
    }
  }
`;
exports.PUBLIC_CHANNEL_FRAGMENT = `
  fragment PublicChannelFragment on Channel {
    id
    title
    description
    tags
    categories
    featuredVideoId
    source
    cover {
      selected
    }
    uploadedTrailer {
      status
    }
    pricing {
      type
      price
      period
      enabled
      currency
      required
    }
  }
`;
//# sourceMappingURL=fragments.js.map